import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TransportBookingForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import DateTimeInput from '../../../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import NumberInput from '../../../../../../moreCore/UI/NumberInput/NumberInput';
import SearchSelect from '../../../../../../moreCore/UI/SearchSelect/SearchSelect';
import { AdditionalFormSaveData, TravelBookingLoadData } from "../../../TravelBookingListTypes";

class TransportBookingForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private entity: TravelBookingLoadData;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private durationInput: MdsLax<InstanceType<typeof NumberInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private alternativeTimeInput: MdsLax<InstanceType<typeof SearchSelect>>;

    private currentDateStart: Date;
    private currentDuration: number;
    private currentDateEnd: Date;

    onInputChange(e): void {
        this.emit("change");
    }

    getData(): AdditionalFormSaveData {
        var formData: AdditionalFormSaveData = {
            date_start: this.dateToLocalISOString(this.dateStartInput.getValue().date),
            duration: this.durationInput.getValue(),
            date_end: this.dateToLocalISOString(this.dateEndInput.getValue().date),
            alternativeTimeId: this.alternativeTimeInput.getValue(),
        };

        return formData;
    }



    prepareData(entity?): void {
        if (entity) {
            this.setEntity(entity);
        } else {
            this.dateStartInput.setValue(null, true);
            this.durationInput.setValue(null, true);
            this.dateEndInput.setValue(null, true);
            this.alternativeTimeInput.setValue(null, true);
        }

        this.currentDateStart = this.dateStartInput.getValue().date;
        this.currentDateEnd = this.dateEndInput.getValue().date;
        this.currentDuration = this.durationInput.getValue();
    }

    private _resetInputs(): void {
        this.dateStartInput.setValue(this.currentDateStart, true);
        this.dateEndInput.setValue(this.currentDateEnd, true);
        this.durationInput.setValue(this.currentDuration, true);
    }

    private _onChangeDateStart(e: Event): void {
        var dateStart = this.dateStartInput.getValue().date;
        var dateEnd = this.dateEndInput.getValue().date;
        var duration = this.durationInput.getValue();

        var success = true;

        if (dateStart && dateEnd) {
            if (duration) {
                var newDateEnd = new Date(dateStart.toString());
                newDateEnd.setTime(newDateEnd.getTime() + duration * 1000 * 60 * 60);
                this.dateEndInput.setValue(newDateEnd, true);
            } else {
                if (this.compareDates(dateStart, dateEnd) <= 0) {
                    var newDuration = this.calculateHourDifference(dateStart, dateEnd);
                    this.durationInput.setValue(newDuration, true);
                } else {
                    success = false;
                    this.showToast(this.translate("TravelBookingForm_Error_DateStart"), "fas fa-exclamation-triangle");
                }
            }
        }

        if (success) {
            this.currentDateStart = this.dateStartInput.getValue().date;
            this.currentDateEnd = this.dateEndInput.getValue().date;
            this.currentDuration = this.durationInput.getValue();

            this.onInputChange(e);
        } else {
            this._resetInputs();
        }
    }

    private _onChangeDateEnd(e) {
        var dateStart = this.dateStartInput.getValue().date;
        var dateEnd = this.dateEndInput.getValue().date;

        var success = true;

        if (dateStart && dateEnd) {
            if (this.compareDates(dateEnd, dateStart) >= 0) {
                var newDuration = this.calculateHourDifference(dateStart, dateEnd);
                this.durationInput.setValue(newDuration, true);
            } else {
                success = false;
                this.showToast(this.translate("TravelBookingForm_Error_DateEnd"), "fas fa-exclamation-triangle");
            }
        }

        if (success) {
            this.currentDateStart = this.dateStartInput.getValue().date;
            this.currentDateEnd = this.dateEndInput.getValue().date;
            this.currentDuration = this.durationInput.getValue();

            this.onInputChange(e);
        } else {
            this._resetInputs();
        }
    }

    private _onChangeDuration(e) {
        if (this.dateStartInput.getValue().date && this.dateEndInput.getValue().date && this.durationInput.getValue() >= 0) {
            var newDuration = this.durationInput.getValue();
            var dateStart = this.dateStartInput.getValue().date;
            var newDateEnd = new Date(dateStart.toString());
            newDateEnd.setTime(newDateEnd.getTime() + newDuration * 1000 * 60 * 60);
            this.dateEndInput.setValue(newDateEnd, true);

            this.currentDuration = newDuration;
            this.currentDateEnd = newDateEnd;

            this.onInputChange(e);
        } else {
            this.durationInput.setValue(this.currentDuration);
        }
    }

    private calculateHourDifference(dateStart: Date, dateEnd: Date): number {
        var timeDifference = dateEnd.getTime() - dateStart.getTime();

        var hourDifference = Math.round(timeDifference / (1000 * 60 * 60));

        return hourDifference;
    }

    private compareDates(date1: Date, date2: Date): number {
        var result: number;

        result = date1.getTime() - date2.getTime();

        //If result === 0: date1 and date2 are equal
        //If result < 0: date2 is greater than date1
        //If result > 0: date1 is greater than date2
        return result;
    }

    private setEntity(entity: TravelBookingLoadData): void {
        this.entity = entity;
        this.dateStartInput.setValue(entity.date_start, true);
        this.durationInput.setValue(entity.duration / 60, true);
        this.dateEndInput.setValue(entity.date_end, true);
        this.alternativeTimeInput.setValue(entity.ref_alternative_time_text, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.alternativeTimeInput.loadListValues();

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TransportBookingForm);